import { render } from "./PopupSuccess.vue?vue&type=template&id=e424cde6"
import script from "./PopupSuccess.vue?vue&type=script&lang=js"
export * from "./PopupSuccess.vue?vue&type=script&lang=js"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__